export default class Navigation {
  PREV_STICKY = '';

  STICKY_TAB_NAVI = 'tab-navigation';

  constructor() {
    this.nHeaderHeight = TMON.oApp.oUtil.getHeaderHeight();

    this.htOpacityInfo = {
      nStartOpacity: 0.001,
      nEndOpacity: 1,
      nMinTop: 20,
      nMaxTop: 100,
    };
  }

  /**
   * onScroll
   * window.onScroll 되었을 때 호출됨
   * @param nScrollTop
   */
  onScroll(nScrollTop) {
    this.setOpacity(nScrollTop);
    this.setFixed(nScrollTop);
  }

  /**
   * setOpacity
   * 헤더, 브레드크럼스같이 스크롤값에 의해 opacity 가 결정되는 UI 들을 컨트롤함
   * @param nScrollTop
   */
  setOpacity(nScrollTop) {
    const nOpacity =
      this.htOpacityInfo.nStartOpacity +
      (this.htOpacityInfo.nEndOpacity - this.htOpacityInfo.nStartOpacity) *
        Math.min(
          Math.max(nScrollTop - this.htOpacityInfo.nMinTop, 0) /
            (this.htOpacityInfo.nMaxTop - this.htOpacityInfo.nMinTop),
          1
        );
    $('._opacityChangeItem').css({
      opacity: nOpacity,
      visibility: nOpacity <= 0.1 ? 'hidden' : 'visible',
    });
  }

  /**
   * setFixed
   * 브레드크럼스, 탭 내비게이션과 같이 스크롤값에 의해 fixed, unfixed 가 결정되는 UI 들을 컨트롤함
   * @param nScrollTop
   */
  setFixed(nScrollTop) {
    let welCurrentItem = '';
    let nRefineScrollTop = nScrollTop;
    let sLastStickyId = '';
    const welTabWrapHeight = $('.tab-wrap').height();
    if (nScrollTop < 0) {
      nRefineScrollTop = 0;
    }

    for (let i = 0; i < $('._fixedUIItem').length; i += 1) {
      welCurrentItem = $(`._fixedUIItem:eq(${i})`);
      const stickyId = welCurrentItem.attr('data-sticky-id');
      const stickyItemOffsetTop = welCurrentItem
        .closest('._fixedUIWrap')
        .offset().top;

      // PC에서 스크롤시 브래드크럼을 네이게이션 뒤로 숨김처리(SDLUI-1147 로 인한 이슈대응)
      if (TMON.oApp.sPlatform === 'PW') {
        if (
          stickyItemOffsetTop - 1 <=
          nRefineScrollTop + this.nHeaderHeight + welTabWrapHeight
        ) {
          if (this.STICKY_TAB_NAVI === stickyId) {
            welCurrentItem.closest('.tab-wrap').addClass('z_index');
          }
        } else if (this.STICKY_TAB_NAVI === stickyId) {
          welCurrentItem.closest('.tab-wrap').removeClass('z_index');
        }
      }

      if (
        nRefineScrollTop !== 0 &&
        stickyItemOffsetTop - 1 <= nRefineScrollTop + this.nHeaderHeight
      ) {
        if (this.PREV_STICKY !== stickyId) {
          this.PREV_STICKY = stickyId;
          this.setStickyUi(welCurrentItem, stickyId);

          sLastStickyId = stickyId;
        }
      } else {
        this.setReleaseUi(welCurrentItem, stickyId);
      }
    }

    if (TMON.oApp.getStorage('sticky') !== sLastStickyId) {
      TMON.oApp.setStorage('sticky', sLastStickyId);
    }
  }

  /**
   * setStickyUi
   * UI 를 fixed 함
   * @param wel
   */
  setStickyUi(wel, stickyId) {
    if (TMON.oApp.sPlatform === 'PW') {
      // PC sticky 제어
      if (this.STICKY_TAB_NAVI === stickyId) {
        $('.path-nav-wrap ._fixedUIItem').addClass('disabled');
      }
      wel.addClass('fixed _fixed');
    } else {
      // Mobile sticky 제어
      if (!wel.attr('data-origin-position')) {
        wel.attr('data-origin-position', wel.css('position'));
      }
      if (!wel.attr('data-origin-zindex')) {
        wel.attr('data-origin-zindex', wel.css('zIndex'));
      }
      wel
        .css({
          position: 'fixed',
          top: this.nHeaderHeight,
          zIndex: 300,
        })
        .addClass('fixed _fixed');
    }
  }

  /**
   * setReleaseUi
   * UI 를 release (unfixed) 함
   * @param wel
   */
  setReleaseUi(wel, stickyId) {
    if (TMON.oApp.sPlatform === 'PW') {
      wel.removeClass('fixed _fixed');
      if (this.STICKY_TAB_NAVI === stickyId) {
        $('.path-nav-wrap ._fixedUIItem').removeClass('disabled');
      }
    } else {
      wel
        .css({
          position: wel.attr('data-origin-position'),
          top: 'auto',
          zIndex: wel.attr('data-origin-zindex'),
          '-webkit-transform': 0,
          '-ms-transform': 0,
          transform: 0,
        })
        .removeClass('fixed _fixed');
    }
  }
}
